import SessionsList from "../../components/SessionsList";
import { useAuth } from "../../context/AuthContext";

export default function StudentSessions() {
  const { user } = useAuth();

  return (
    <SessionsList
      userRole="student"
      userId={user?.id}
      showHeader={true}
      title="Bookings & Sessions"
      subtitle="All your requests and scheduled sessions"
    />
  );
}
